<template>
  <div class="all-events-container">
    <div class="banner-all-events">
      banner
    </div>
    <div class="grid-container">
      <div class="grid-content">
        <h1>Todos los eventos</h1>
        <div class="content-card">
          <cards
            v-for="item in getAllEvents"
            :key="item.id"
            :data="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cards from '../_shared/mt-card-event'
export default {
  name: 'AllEvents',
  components: {
    cards
  },
  data () {
    return {
      event: {}
    }
  },
  computed: {
    getAllEvents () {
      return this.$store.getters['events/items']
    }
  },
  mounted () {
    this.$store.dispatch('events/get')
  }
}
</script>

<style lang="scss" scoped>

  .all-events-container{
    margin-top: 70px;
    h1{
      margin: 0;
      margin-left: 10px;
    }
    .banner-all-events{
      width: 100%;
      height: 300px;
      border: 1px solid red;
    }
  }

  .content-card{
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));

    .card-container{
      margin-bottom: 10px;
      @media #{$iPhone} {
        width: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/events/all-events.vue